/**
 * Kayıt Bazlı İşlem Geçmişi (Entity Audit Trail) servisi.
 *
 * Backend: gts_accounting_api → GET /api/entity-history/list
 * (EntityChangeLogs, tenant DB — ApplicationDbContext SaveChanges denetim motoru yazar).
 * Yetki: admin / subadmin / manager (ManagementRoleOnly, imza doğrulamalı own-JWT).
 *
 * Parent eşleşmesi backend'de yapılır: örn. entityType='Invoice' sorgusu, faturanın
 * kendi değişiklikleriyle birlikte kalem (InvoiceItem) değişikliklerini de döner.
 */
import { accountingApi } from '../config/apiClient';

export interface EntityFieldChange {
  field: string;
  old: string | null;
  new: string | null;
}

export interface EntityChangeLogEntry {
  id: number;
  entityType: string;
  entityId: string;
  parentEntityType: string | null;
  parentEntityId: string | null;
  changeType: 'Created' | 'Updated' | 'Deleted';
  changesJson: string | null;
  actorUid: string | null;
  actorName: string | null;
  actorRole: string | null;
  apiName: string | null;
  createdAt: string;
}

export interface EntityHistoryPage {
  items: EntityChangeLogEntry[];
  total: number;
  page: number;
  pageSize: number;
}

export async function getEntityHistory(
  entityType: string,
  entityId: string | number,
  page: number = 1,
  pageSize: number = 20
): Promise<EntityHistoryPage> {
  const response = await accountingApi.get('/api/entity-history/list', {
    params: { entityType, entityId: String(entityId), page, pageSize },
  });
  const data = response.data;
  if (!data?.success) {
    throw new Error(data?.message || 'İşlem geçmişi alınamadı.');
  }
  return {
    items: data.data ?? [],
    total: data.total ?? 0,
    page: data.page ?? page,
    pageSize: data.pageSize ?? pageSize,
  };
}

/** ChangesJson'ı güvenli parse eder; bozuksa boş liste döner. */
export function parseFieldChanges(changesJson: string | null): EntityFieldChange[] {
  if (!changesJson) return [];
  try {
    const parsed = JSON.parse(changesJson);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
